// Reading Progress Bar
(function() {
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  function init() {
    var headerSection = document.querySelector('.section-header');
    if (!headerSection) return;

    var bar = document.createElement('div');
    bar.id = 'reading-progress-bar';
    bar.setAttribute('aria-hidden', 'true');
    headerSection.appendChild(bar);

    var isMobile = window.matchMedia('(max-width: 749px)');

    function update() {
      var h = document.documentElement.scrollHeight - window.innerHeight;
      var pct = h > 0 ? (window.scrollY / h) * 100 : 0;
      if (isMobile.matches) {
        bar.style.width = '';
        bar.style.setProperty('height', pct + '%', 'important');
      } else {
        bar.style.removeProperty('height');
        bar.style.width = pct + '%';
      }
    }

    window.addEventListener('scroll', update, { passive: true });
  }
})();
